import React from 'react'
import { IconSeeker } from '@ui-seeker/core'
import { AppBulkEditAction, AppDialogCancel } from '@components'
import { selectedMappingId } from 'Pages/User/CustomMapping/@signals'
import useMappingForm from 'Pages/User/CustomMapping/EditDrawer/@hooks/useForm'
import { batch, useComputed } from '@preact/signals-react'
import { formData, formErrors } from '@signals'


export default function MappingDrawerFooter() {

	const method = useComputed(() => formData.value?.method)
	const { submitPayload, isFormSubmitting } = useMappingForm(method.value)
	const isValid = useComputed(() => Object.values(formErrors.value).every(e => e))

	return <>
		<AppDialogCancel onClick={() => batch(() => {
			selectedMappingId.value = null
			formData.value = {}
		})}/>
		<AppBulkEditAction
			sx={{ minWidth: 103 }}
			startIcon={<IconSeeker icon="floppy-disk"/>}
			loading={!!isFormSubmitting}
			onClick={submitPayload}
			disabled={!isValid.value}
		>
			Save
		</AppBulkEditAction>
	</>
}
